module.exports = __webpack_public_path__ + "static/img/kuaishou2.ddf76e2a.png";